import { Dispatch, SetStateAction } from 'react';
import { useDispatch } from 'react-redux';
import welcomeImage from '../../assets/images/backoffice/MavieWelcome.png';
import welcomeImage2 from '../../assets/images/backoffice/stakingHubNft.png';
import { SidebarModal } from '../../components/common/Sidebar/Sidebar';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { H2, H4, P2 } from '../../styles/FontStyles';
import { Button } from '../../styles/GlobalComponents';
import { colors } from '../../styles/GlobalStyles';
import { Icon, IconCheck } from '../../styles/Icons';
import { FlexCenter } from '../../styles/stylesStyled';
import { checkSideModal } from './Dashboard.actions';

interface WelcomeSidebarProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export const WelcomeSidebar = ({ open, setOpen }: WelcomeSidebarProps) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation('dashboard');

  const clickBuy = () => {
    dispatch(checkSideModal(history));
  };

  const welcomeData = [
    t('welcome.text1'),
    t('welcome.text2'),
    t('welcome.text3'),
    t('welcome.text4'),
    t('welcome.text5')
  ];

  return (
    <SidebarModal
      isOpen={open}
      setOpen={setOpen}
      sidebarWidth={'508px'}
      hasCloseButton={false}
      overlayClose={true}>
      <img style={{ width: '100%' }} src={welcomeImage} alt='welcome' />
      <H2 m='40px 0'>{t('welcome.welcome_to_mavie_community')}</H2>
      <H4 m='20px 0'>{t('welcome.start_with')}</H4>

      {welcomeData.map((data, i) => (
        <FlexCenter key={i} style={{ gap: 15, margin: '20px 0' }}>
          <Icon>
            <IconCheck />
          </Icon>
          <P2 color={colors.neutral700}>{data}</P2>
        </FlexCenter>
      ))}
      <Button onClick={clickBuy}>{t('welcome.start_here')}</Button>
      <Button onClick={() => setOpen(false)} textButton>
        {t('welcome.maybe_later')}
      </Button>
    </SidebarModal>
  );
};

const Box = styled.div`
  border-radius: 20px;
  overflow: hidden;

  > div:nth-child(1) {
    padding: 20px;
    background-color: ${({ theme }) => theme.colors.primary900};
  }
  > div:nth-child(2) {
    padding: 30px;
    background-image: url(${welcomeImage2});
    background-size: cover;
    background-position: center center;
  }
`;
